module.exports = __webpack_public_path__ + "static/img/plm8.fd406f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plm8.png
// module id = Ugo7
// module chunks = 73